import React, { useEffect } from 'react';
import { light, dark } from '@servicetitan/anvil-themes';
import { usePrefersColorScheme } from './usePrefersColorScheme';
function capitalizeFirstLetter(string) {
    return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
}
function flattenObj(obj, parent, res = {}) {
    for (const key in obj) {
        const propName = parent
            ? `${parent}` + capitalizeFirstLetter(key)
            : key;
        if (typeof obj[key] === 'object') {
            flattenObj(obj[key], propName, res);
        }
        else {
            res[propName] = obj[key];
        }
    }
    return res;
}
const createStyleTag = (themeObject) => {
    const themeVar = flattenObj(themeObject);
    let styleTag = document.getElementById('themeVariables');
    if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.setAttribute('id', 'themeVariables');
        document.head.appendChild(styleTag);
    }
    let style = ':root{';
    for (const key in themeVar) {
        style += `--${key}:${themeVar[key]};`;
    }
    style += '}';
    styleTag.textContent = style;
};
export const ThemeProvider = ({ theme, children }) => {
    const { theme: systemPreferred } = usePrefersColorScheme(light, dark);
    useEffect(() => {
        createStyleTag(theme !== null && theme !== void 0 ? theme : systemPreferred);
    }, [theme, systemPreferred]);
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=ThemeProvider.js.map